import React from 'react';
import DeliveryTemplate from '@/modules/Checkout/DeliveryTemplate';
import FulfillmentRequiredPopup from '@/modules/Checkout/DeliveryTemplate/FulfillmentRequiredPopup';
import { HEADER_COLLAPSIBLE_MAX_WIDTH } from '@/constants';
import { storeNavigationIntent } from '@/helpers/fulfillmentNavigation';

export const OPEN_FULFILLMENT_PANEL = 'openFulfillmentPanel';

const isMenuPage = () =>
	typeof window !== 'undefined' && window.location.pathname.includes('/menu/');

const shouldOpenShopPanel = () => {
	if (typeof window === 'undefined' || !isMenuPage()) return false;
	return window.innerWidth <= HEADER_COLLAPSIBLE_MAX_WIDTH;
};

const openDeliveryTemplatePopup = (openPopup, { initialTab, redirectAfterConfirm }) => {
	openPopup(
		<DeliveryTemplate
			initialTab={initialTab}
			redirectAfterConfirm={redirectAfterConfirm}
		/>,
		{ className: 'delivery-template-popup' }
	);
};

export const openFulfillmentSelection = (openPopup, closePopup, options = {}) => {
	const { initialTab = 'delivery', redirectAfterConfirm = false } = options;

	if (redirectAfterConfirm) {
		storeNavigationIntent(redirectAfterConfirm);
	}

	const openSelection = () => {
		if (shouldOpenShopPanel()) {
			window.dispatchEvent(
				new CustomEvent(OPEN_FULFILLMENT_PANEL, {
					detail: { redirectAfterConfirm },
				})
			);
			return;
		}

		openDeliveryTemplatePopup(openPopup, { initialTab, redirectAfterConfirm });
	};

	closePopup();
	requestAnimationFrame(openSelection);
};

export const readPendingAddress = () => {
	if (typeof window === 'undefined') return null;
	try {
		const raw = sessionStorage.getItem('pending_address');
		return raw ? JSON.parse(raw) : null;
	} catch {
		return null;
	}
};

export const getHasFulfillmentSelection = ({
	checkoutData,
	selectedAddresses,
	hasAddressType,
	isLoggedIn,
	branches = [],
	pendingAddress,
}) => {
	const isTakeaway = checkoutData?.fulfillmentType === 'takeaway';
	const selectedBranch =
		branches.find((b) => Number(b.id) === Number(checkoutData?.fulfillmentBranchId)) || null;
	const selectedAddress = hasAddressType ? selectedAddresses?.shipping || null : selectedAddresses || null;
	const pending = pendingAddress ?? readPendingAddress();

	if (isTakeaway && checkoutData?.fulfillmentBranchId && selectedBranch) return true;
	if (!isTakeaway && selectedAddress) return true;
	if (!isLoggedIn && pending) return true;
	return false;
};

export const isCartOrCheckoutUrl = (url) => {
	const path = typeof url === 'object' ? url?.pathname || '' : url || '';
	return path.includes('/cart/') || path.includes('/checkout/');
};

export const showFulfillmentRequiredPopup = (openPopup, closePopup, options = {}) => {
	const { initialTab = 'delivery', redirectAfterConfirm = false } = options;

	if (redirectAfterConfirm) {
		storeNavigationIntent(redirectAfterConfirm);
	}

	openPopup(
		<FulfillmentRequiredPopup
			titleKey='deliveryTemplate.fulfillmentSelectionRequired'
			onConfirm={() =>
				openFulfillmentSelection(openPopup, closePopup, { initialTab, redirectAfterConfirm })
			}
		/>,
		{ className: 'cart-modification-warning-popup' }
	);
};
